import { Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "@/layouts/MainLayout";
import CatalogView from "@/components/views/CatalogView";

// Administration pages
import Units from "@/pages/Administration/Units";
import UnitDetail from "@/pages/Administration/Units/_id";
import Employees from "@/pages/Employees/Employees";
import EmployeeDetail from "@/pages/Employees/Employees/_id";
import TimeTracking from "@/pages/Employees/TimeTracking";
import Users from "@/pages/Administration/Users";
import UserDetail from "@/pages/Administration/Users/_id";
import SystemSettings from "@/pages/Administration/SystemSettings";
import SystemLogging from "@/pages/Administration/SystemLogging";
import NoticeSettings from "@/pages/Administration/NoticeSettings";
import ReportSettings from "@/pages/Administration/SystemSettings/ReportSettings";
import RequestSettings from "@/pages/Administration/SystemSettings/RequestSettings";
import RequestPreview from "@/pages/Administration/SystemSettings/RequestSettings/RequestPreview";

// Guides
import Positions from "@/pages/Guides/Positions";
import Priorities from "@/pages/Guides/Priorities";
import Statuses from "@/pages/Guides/Statuses";
import UnitTypes from "@/pages/Guides/UnitTypes";
import TaskTypes from "@/pages/Guides/TaskTypes";
import SprintStatuses from "@/pages/Guides/SprintStatuses";

// Resources
import Definitions from "@/pages/Administration/ResourcesSettings/Definitions";
import DefinitionDetail from "@/pages/Administration/ResourcesSettings/Definitions/_id";
import TabularFormView from "@/pages/Administration/ResourcesSettings/Definitions/FormsViews/tabular-form";
import ObjectFormSettings from "@/pages/Administration/ResourcesSettings/Definitions/FormsViews/object-form";
import FiltersSettings from "@/pages/Administration/ResourcesSettings/Definitions/FormsViews/filters";

// Common pages
import Tasks from "@/pages/Tasks";
import TaskDetail from "@/pages/Tasks/_id";
import Objects from "@/pages/Objects";
import ObjectsDetail from "@/pages/Objects/_id";
import FolderView from "@/pages/Folder";
import TaskTemplates from "@/pages/TaskTemplates";
import TaskTemplateDetail from "@/pages/TaskTemplates/_id";
import Sprints from "@/pages/Sprints";
import SprintsDetail from "@/pages/Sprints/_id";
import Search from "@/pages/Search";

import NotFound from "@/pages/NotFound";
import NSPDSettings from "@/pages/Administration/NSPDSettings";

const AdminRoutes = ({ config, redDot }) => (
  <MainLayout isAdmin={true} config={config} redDot={redDot}>
    <Routes>
      <Route path="employees">
        <Route
          index
          element={<Navigate to="/administration/employees/e-list" />}
        />
        <Route path="e-list">
          <Route index element={<Employees />} />
          <Route path=":id" element={<EmployeeDetail />} />
        </Route>
        <Route path="time-tracking" element={<TimeTracking />} />
      </Route>

      <Route path="guides">
        <Route path="positions" element={<Positions />} />
        <Route path="priorities" element={<Priorities />} />
        <Route path="statuses" element={<Statuses />} />
        <Route path="unit-types" element={<UnitTypes />} />
        <Route path="task-types" element={<TaskTypes />} />
        <Route path="sprint-statuses" element={<SprintStatuses />} />
      </Route>

      <Route path="all-units">
        <Route index element={<Units />} />
        <Route path=":id" element={<UnitDetail />} />
      </Route>

      <Route path="users">
        <Route index element={<Users />} />
        <Route path=":id" element={<UserDetail />} />
      </Route>

      <Route path="all-tasks">
        <Route path="all-t-list">
          <Route index element={<Tasks isAdmins />} />
          <Route path=":id" element={<TaskDetail isAdmins />} />
        </Route>
        <Route path="all-t-templates">
          <Route index element={<TaskTemplates isAdmins />} />
          <Route path=":id" element={<TaskTemplateDetail isAdmins />} />
        </Route>
      </Route>

      <Route path="all-files" element={<CatalogView isAdmins />}>
        <Route path=":id" element={<FolderView isAdmins />} />
      </Route>

      <Route path="all-objects">
        <Route path=":definitionId" element={<Objects isAdmins />} />
        <Route
          path=":definitionId/:objectId"
          element={<ObjectsDetail isAdmins />}
        />
      </Route>

      <Route path="all-sprints">
        <Route index element={<Sprints isAdmins />} />
        <Route path=":id" element={<SprintsDetail isAdmins />} />
      </Route>

      <Route path="resources">
        <Route path="structures">
          <Route path=":type">
            <Route index element={<Definitions />} />
            <Route path=":id">
              <Route index element={<DefinitionDetail />} />
              <Route path="setting-table-form" element={<TabularFormView />} />
              <Route path="setting-filters" element={<FiltersSettings />} />
              <Route
                path="setting-object-form"
                element={<ObjectFormSettings />}
              />
            </Route>
          </Route>
        </Route>
      </Route>

      <Route path="system-settings">
        <Route index element={<SystemSettings />} />
        <Route path="reports/:id" element={<ReportSettings />} />
        <Route path="requests/:id" element={<RequestSettings />} />
        <Route path="requests-preview/:uuid/:id" element={<RequestPreview />} />
      </Route>
      <Route path="nspd-settings" element={<NSPDSettings />} />
      <Route path="system-logging" element={<SystemLogging />} />
      <Route path="notice-settings" element={<NoticeSettings />} />

      <Route path="search" element={<Search isAdmins />} />

      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  </MainLayout>
);

export default AdminRoutes;
